// Asset imports - bundler handles path resolution
import gcalendarIcon from '~/static/assets/icons/landing-page/gcalendar_icon.svg';
import outlookIcon from '~/static/assets/icons/landing-page/outlook_icon.svg';

type Provider = 'google' | 'microsoft' | string;

const providerIcons: Record<string, ImageAsset> = {
  google: gcalendarIcon,
  microsoft: outlookIcon,
};

export const getProviderIcon = (provider: Provider): ImageAsset | undefined => {
  return providerIcons[provider];
};

// Format provider name for display
export const getProviderDisplayName = (provider: Provider): string => {
  return provider === 'google' ? 'Google' : 'Microsoft';
};
